<template>
    <div class="custom-control custom-radio">
        <input
            class="custom-control-input"
            :class="{'is-invalid': valid === false}"
            type="radio"
            :id="identifier"
            :value="value"
            :checked="value === fieldValue"
            @change="updateValue($event.target.value)"
            v-bind="$attrs"
            :aria-invalid="!valid"
            :aria-describedby="identifierError"
        >
        <label class="custom-control-label" :for="identifier" v-if="label" v-html="label + requiredAsterisk"></label>
        <span
            v-if="infoText"
            class="info-button-radio"
            data-trigger="hover focus"
            data-container="body"
            v-popover data-placement="top"
            data-html="true"
            data-original-title=""
            title=""
            :data-content="infoText"
            tabindex="0"
        ></span>
        <div :id="identifierError" class="invalid-tooltip" v-html="errorMessages" />
    </div>
</template>
<script>
import FormField from "@/mixins/FormField";

export default {
    name: 'RadioInput',
    props: {
        value: {
            type: String,
            required: true,
        },
        infoText: {
            type: String,
            required: false,
            default: ''
        }
    },
    mixins: [FormField],
    inheritAttrs: false,
}
</script>
